var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVhdLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 25,
    viewBox: "0 0 74 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.28873 0.168457L12.2653 18.9554H12.4947L18.4833 0.168457H24.2788L15.7546 24.8957H9.01742L0.481201 0.168457H6.28873Z",
    fill: "#00979E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.255 24.8957V0.168457H32.483V10.3709H43.0959V0.168457H48.3118V24.8957H43.0959V14.6812H32.483V24.8957H27.255Z",
    fill: "#00979E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3878 24.8957H52.6222V0.168457H61.4603C63.9475 0.168457 66.0886 0.663486 67.8835 1.65354C69.6785 2.63555 71.059 4.04819 72.0249 5.89147C72.9988 7.73475 73.4858 9.94024 73.4858 12.5079C73.4858 15.0837 72.9988 17.2972 72.0249 19.1486C71.059 20.9999 69.6705 22.4206 67.8594 23.4106C66.0564 24.4007 63.8992 24.8957 61.3878 24.8957ZM57.8502 20.4163H61.1705C62.7159 20.4163 64.0159 20.1427 65.0703 19.5953C66.1328 19.0399 66.9297 18.1827 67.461 17.0236C68.0003 15.8564 68.2699 14.3512 68.2699 12.5079C68.2699 10.6808 68.0003 9.18763 67.461 8.02854C66.9297 6.86945 66.1369 6.01623 65.0824 5.46888C64.028 4.92154 62.728 4.64786 61.1826 4.64786H57.8502V20.4163Z",
    fill: "#00979E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVhdLogo);
export default __webpack_public_path__ + "static/media/vhd-logo.b7dccbe3b674d591b024d541c699df25.svg";
export { ForwardRef as ReactComponent };